import * as AuthService from './auth';

export const host: string = String(process.env.REACT_APP_BADMIN_API_HOST);

async function request(method: string, url: string, body?: any): Promise<Response> {
	const options: any = { method, headers: { 'Content-Type': 'application/json' } };
	// todo: access token send via cookies
	const token: any = localStorage.getItem('bb_token');

	if (token) options.headers.Authorization = `Bearer ${token}`;
	if (body) options.body = JSON.stringify(body);

	const response: Response = await fetch(url, options);

	if (response.status === 401) {
		AuthService.clearAuthStorage();
		window.location.href = '/login';
	}

	if (response.statusText === 'Bad Gateway') {
		return response;
	}

	if (response.ok === false) {
		throw new Error(await response.text());
	}

	return response;
}

export async function get(url: string): Promise<Response> {
	const response: Response = await request('GET', url);
	return response;
}

export async function post(url: string, body: any): Promise<Response> {
	const response: Response = await request('POST', url, body);
	return response;
}

export async function put(url: string, body: any): Promise<Response> {
	const response: Response = await request('PUT', url, body);
	return response;
}

export async function patch(url: string, body: any): Promise<Response> {
	const response: Response = await request('PATCH', url, body);
	return response;
}

export async function del(url: string): Promise<Response> {
	const response: Response = await request('DELETE', url);
	return response;
}
